import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import Button from '@/ui-kit/components/Button/Button';

const WithdrawalInProgress = ({ closeModal }: ModalProps) => {
  const { t } = useTranslation('Modal');

  return (
    <Modal title={t('WithdrawalInProgress.title')}>
      <p>{t('WithdrawalInProgress.info')}</p>
      <ModalActions>
        <Button onClick={closeModal}>{t('WithdrawalInProgress.clear')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default WithdrawalInProgress;
